<style>

h3{
  text-align: center;
}

.card{
  background-color: rgba(0,0,0,0.4);
  color: white;
  border-radius: 20px;
  margin: 10px;
  padding: 1px 1px 20px 1px;
}
.question{
  margin: 28px;
}
.slider{
  padding: 0 20px;
}

.text{
  display: grid;
  grid-template-columns: 16px auto auto 16px;
  font-size: 16px;
  margin: 5px;
}
.left-arrow{
  grid-column: 1;
}
.left-text{
  grid-column: 2;
}
.right-text{
  grid-column: 3;
  text-align: right;
}
.right-arrow{
  grid-column: 4;
}

</style>

<Auth bind:this="{auth}"></Auth>
<Profile bind:this="{profile}" bind:me="{me}"></Profile>

{#if show}

<h3>Match Questions</h3>
  
{#each Questions as item}

  {#if item.type == 'scale0-5'}
  
    {#if showAllHelper(item)}
    
    <div class="card">
      
      <div class="question">Q: {item.question}</div>
      <div class="question">A: { item.selected[0] != 0 ? item.answers[ item.selected[0] - 1 ] : 'No Answer' }</div>
      
      <div class="slider">
        <RangeSlider id="matchQuestion1" min="{0}" max="{5}" pips bind:values="{item.selected}" springValues="{ { stiffness: 0.25, damping: 0.9 } }"></RangeSlider>
      </div>
      
      <div class="text">
        <div class="left-arrow"><i class="icon-arrow_left"></i></div>
        <div class="left-text">{item.leftText}</div>
        <div class="right-text">{item.rightText}</div>
        <div class="right-arrow"><i class="icon-arrow_right"></i></div>
      </div>
      
    </div>
    
    {/if}
  
  {/if}

{/each}

{/if}

<script>

import { createEventDispatcher } from 'svelte';
const dispatch = createEventDispatcher();

import Auth from "../../interfaces/Auth.svelte";
let auth;

import Profile from "../../interfaces/Profile.svelte";
let profile;

import RangeSlider from "svelte-range-slider-pips";
import Questions from "../../helpers/Questions.js";
import Validate from "../../helpers/Validate.js";
import Normalize from "../../helpers/Normalize.js";

export let show = false;
export let me = null;


import { onMount } from "svelte";
onMount(async () => {
  set();
});


$:{
  if (me) set();
}


function set() {
  // associate localStorage with Questions
  for (let i in Questions) {
    if (Questions[i].default == true) {
      if (Questions[i].i in me.questions) {
        Questions[i].selected[0] = me.questions[Questions[i].i];
      } else {
        // we don't know how many default questions there are
        // so, we build an array based on how many default questions.  this could change,
        // so we don't define a static array
        Questions[i].selected[0] = 0;
      }
    }
  }
}


function showAllHelper(item) {
  if (item.default == true) {
    return true;
  }
  
  return false;
}


function check() {
  try {
  } catch (e) {
    console.log("error:", e);
  }
}


export const save = async () => {
  // save the component to saveMe
  
  // me.questions = questions;
  let questions = [];
    
  for (let i in Questions) {
    if (Questions[i].default == true) {
      questions[Questions[i].i] = Questions[i].selected[0];
    }
  }
  
  me.questions = questions;
  
  // eventually we'll do a compare here to verify changes...
  // if (questions != me.questions) {
  //   me.questions = questions;
  await profile.updateMe( { updateShare: true } );
  // }
}



</script>